import "./App.css";
import TrendingMap from "./components/TrendingMap";
import { RecoilRoot } from "recoil";
import { RecoilURLSyncJSON } from "recoil-sync";
import "mapbox-gl/dist/mapbox-gl.css";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/ErrorFallback";
import React, { Suspense } from "react";
import PhotoHistogram from "./components/PhotoHistogram";
import CircleToggle from "./components/CircleToggle";
import PhotoSize from "./components/PhotoSize";
import CategoryControl from "./components/CategoryControl";

function App() {
  return (
    <RecoilRoot>
      <RecoilURLSyncJSON location={{ part: "queryParams" }}>
        <div
          style={{
            position: "relative",
            height: "100vh",
            width: "100vw",
            backgroundColor: "grey",
          }}
        >
          <TrendingMap />

          <ErrorBoundary fallback={ErrorFallback}>
            <Suspense fallback={null}>
              <PhotoHistogram height={100} />
            </Suspense>
          </ErrorBoundary>
          <CircleToggle />
          <PhotoSize />
          <Suspense fallback={null}>
            <CategoryControl />
          </Suspense>
        </div>
      </RecoilURLSyncJSON>
    </RecoilRoot>
  );
}

export default App;
